import apiService from './api-service';

const People = {};
const urlEntity = "/people";

People.getOne = (id) => {
    return apiService.get(`${urlEntity}/${id}`)
        .then((res) => res)
};

People.existEmail = (email, currentEmail) => {
    var q = {};
    if (email) {
        q.email = email;
    }
    if (currentEmail) {
        q.current_email = currentEmail;
    }
    return apiService.get(`${urlEntity}/exist-email`, {
        params: q,
    })
        .then((res) => res)
};

People.existDocumentNumber = (document_number, currentDocumentNumber) => {
    var q = {};
    if (document_number) {
        q.document_number = document_number;
    }
    if (currentDocumentNumber) {
        q.current_document_number = currentDocumentNumber;
    }
    return apiService.get(`${urlEntity}/exist-document-number`, {
        params: q,
    })
        .then((res) => res)
};

export default People;
